import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import { Box, TextField } from "@mui/material";
import axios from "axios";
import Loader from "./Loader";
import { useDispatch } from "react-redux";
import { setFieldValue } from "../redux/actions/fileActions";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import 'dayjs/locale/it'
import { _get, _post, _put, _delete } from '../utils/apiServices';


function Form() {
  const dispatch = useDispatch();
  const [fields, setFields] = useState([]);
  const [values, setValues] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
    dispatch(setFieldValue(event.target.name, event.target.value));
  };
  const handleChangeDate = (selectedDate) => {
    if (selectedDate) {
      // Format the selected date to "DD/MM/YYYY"
      const formattedDate = dayjs(selectedDate).format("DD/MM/YYYY");
      // Dispatch the action to update the field value in the store
      dispatch(setFieldValue("data", formattedDate));
    }
  };
  const showFields = async () => {
    setLoading(true);
    try {
      
      const {data}= await _get('/api/fields/show')
      setFields(data.fields);
      setLoading(false);
    } catch (error) {
      console.log(error.response.data.error);
    }
  };

  useEffect(() => {
    showFields();
  }, []);



  return (
    <>
      <Box

        component="form"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center", // Center horizontally
        }}

        //className="form_style border-style"
      >
        {loading ? (
          <Loader />
        ) : (
          fields.map((field, index) => (
            <Box
              sx={{
                width: "100%",
              }}
            >
              <TextField
                sx={{
                  mb: 3,
                  "& .MuiInputBase-root": {
                    color: "text.secondary",
                  },
                  fieldset: { borderColor: "rgb(231, 235, 240)" },
                }}
                fullWidth
                id={field.namePdf}
                label={field.name}
                name={field.namePdf}
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder={field.placeholder}
                value={values[field.namePdf] || ""}
                onChange={handleChange}
                key={`${field.namePdf}-${index}`}
                
                {...(field.namePdf === "nome_scuola" ? { required: true } : {})}

              />
            </Box>
          ))
        )}
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
          <DemoContainer components={["DatePicker"]}>
            <DatePicker

              label="Seleziona la data"
              value={selectedDate}
              onChange={handleChangeDate}
            />
          </DemoContainer>
        </LocalizationProvider>
      </Box>
    </>
  );
}

export default Form;
